import type { WorkerPoolResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import type { FormFieldProps } from "~/components/form";
import WorkerPoolSelect from "~/components/form/WorkerPoolSelect/WorkerPoolSelect";
interface WorkPoolInputProps extends FormFieldProps<string> {
    label: string;
    warning?: string;
    allowClear: boolean;
    defaultValueIndicator: JSX.Element | undefined;
    hideSearch?: boolean;
    doBusyTask(action: () => Promise<void>): Promise<boolean>;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
    items: () => Promise<WorkerPoolResource[]>;
    onRequestRefresh: () => Promise<boolean>;
}
const WorkerPoolInput: React.FC<WorkPoolInputProps> = (props) => {
    const { value, label, warning, allowClear, defaultValueIndicator, doBusyTask, hideSearch, ...rest } = props;
    const formProps = { ...rest, label };
    return (<React.Fragment>
            <WorkerPoolSelect value={value} warning={warning} allowClear={allowClear} doBusyTask={doBusyTask} {...formProps} hideSearch={hideSearch}/>
            {defaultValueIndicator}
        </React.Fragment>);
};
WorkerPoolInput.displayName = "WorkerPoolInput"
export default WorkerPoolInput;
